import { utils } from "./elastic-service.js"
import Vue from "vue"


function createFacet(key, titulo, allFacets, allFilters, closedFacets){
  const facet = utils.extractFacet(allFacets[key])
  const filters =  allFilters[key] || []
  facet.itens.forEach(item => {
    item.text = formatCodigoDescricao(item)
    item.checked = filters.indexOf(item.key) >= 0
  })

  return Vue.observable({
    titulo,
    key,
    isRange: facet.isRange,
    itens: facet.itens,
    filters,
    closed: closedFacets.indexOf(key) >= 0
  })

}

function getItemById(id, list){
  return list.find(v => v.id === id) || list[0]
}

function formatCodigoDescricao(v){
  return (v.codigo? v.codigo + ' - ': "") + v.descricao
}


const state = () => ({
  viewModes: [
    { id: "table", text: "Lista" },
    { id: "card", text: "Resumo" },
    { id: "full", text: "Detalhes" }
  ],

  sortDirections: [
    { id: "asc", text: "Ordem crescente" },
    { id: "desc", text: "Ordem Decrescente" },
  ],

  pagingSizes: [ 10, 20, 40, 100],

  sortFields: [
    { id: "", text: "Relevância" },
    { id: "orgaojulgador", text: "Órgão Julgador" },
    { id: "pessoas", text: "Magistrado" },
    { id: "classe", text: "Classe" },
    { id: "assuntos", text: "Assuntos" }
  ],

  darkMode: false,
  viewMode: "card",
  searchTerm: null,
  sortField: null,
  sortDirection: "asc",
  page: 1,
  resultsPerPage: 20,
  pageCount: 1,
  total: 0,
  filters: {},
  facets: {},
  showFilters: false,
  fullscreen: false,
  currentItem: null,
  closedFacets: [],
  results: [],
  hiddenFacets: ["classe"],
  permanentFilters: [
    {facet: "classe", filter: '{"codigo":"100","descricao":"DÚVIDA"}'},
  ],

  elasticService: null,

})

const getters = {
  formatedResults: state => {
    let curId = state.currentItem? state.currentItem.id : null
    return state.results.map(v => {
      let temp = utils.extractSentenca(v)
      
      temp.selected = temp.id === curId;
      
      temp._assunto = temp.assunto
      temp.assunto = formatCodigoDescricao(temp.assunto)

      temp._classe = temp.classe
      temp.classe = formatCodigoDescricao(temp.classe)

      return temp
    })
  },

  isClosed: (state) => (facetId) => state.closedFacets.indexOf(facetId) >= 0,

  getFacetById: (state, getters) => (facetId) => {
    switch(facetId){
      case "assuntos": return getters.facetAssuntos;
      case "classe": return getters.facetClasse;
      case "competencia": return getters.facetCompetencia;
      case "orgaojulgador": return getters.facetOrgaoJulgador
      case "pessoas": return getters.facetPessoas
      default: return null
    }
  },

  getFilterValue: state => (facet, filter) => {
    //console.log("getFilterValue", {filter})
    return facet.isRanged? ((state.facets[facet.key][0].data.find(v => v.value.name === filter) || {}).value): filter
  },

  facetAssuntos: (state) => {
    return createFacet("assuntos", "Assuntos", state.facets, state.filters, state.closedFacets)
  },

  facetClasse: (state) => {
    return createFacet("classe", "Classe", state.facets, state.filters, state.closedFacets)
  },

  facetCompetencia: (state) => {
    return createFacet("competencia", "Competência", state.facets, state.filters, state.closedFacets)
  },

  facetOrgaoJulgador: (state) => {
    return createFacet("orgaojulgador", "Órgão Julgador", state.facets, state.filters, state.closedFacets)
  },

  facetPessoas: (state) => {
    return createFacet("pessoas", "Pessoas", state.facets, state.filters, state.closedFacets)
  },

  /*eslint no-unused-vars: "off"*/
  formatedFacets: (state, getters) => [
    getters.facetAssuntos,
    getters.facetClasse,
    getters.facetCompetencia,
    getters.facetOrgaoJulgador,
    getters.facetPessoas
  ].filter(v => state.hiddenFacets.indexOf(v.key) < 0),

  config: state => ({
    viewMode: state.viewMode,
    darkMode: state.darkMode,
    showFilters: state.showFilters,
    fullscreen: state.fullscreen,
    closedFacets: state.closedFacets
  })
  
  
}

const mutations = {

  init(state, initial){
    initial = initial || {}
    let v = null
    if((v = initial.darkMode) !== undefined) mutations.setDarkMode(state, v)
    if((v = initial.viewMode) !== undefined) mutations.setViewMode(state, v)
    if((v = initial.searchTerm) !== undefined) mutations.setSearchTerm(state, v)
    if((v = initial.sortField) !== undefined) mutations.setSortField(state, v)
    if((v = initial.sortDirection) !== undefined) mutations.setSortDirection(state, v)
    if((v = initial.page) !== undefined) mutations.setPage(state, v)
    if((v = initial.resultsPerPage) !== undefined) mutations.setResultsPerPage(state, v)
    if((v = initial.pageCount) !== undefined) mutations.setPageCount(state, v)
    if((v = initial.total) !== undefined) mutations.setTotal(state, v)
    if((v = initial.filters) !== undefined) mutations.setFilters(state, v)
    if((v = initial.facets) !== undefined) mutations.setFacets(state, v)
    if((v = initial.showFilters) !== undefined) mutations.setShowFilters(state, v)
    if((v = initial.fullscreen) !== undefined) mutations.setFullscreen(state, v)
    if((v = initial.closedFacets) !== undefined) mutations.setClosedFacets(state, v)
    if((v = initial.currentItem) !== undefined) mutations.setCurrentItem(state, v)
    if((v = initial.results) !== undefined) mutations.setResults(state, v)
    if((v = initial.elasticService) !== undefined) mutations.setElasticService(state, v)
  },

  importDriverState(state, driverState){
    let v = driverState
    this.facets = v.facets;
    this.results = v.results || [];
    mutations.importPagination(state, v.paging)
    mutations.importRawFilters(state, v.filters)

  },

  importRawFilters(state, filters){
    state.filters = (filters || []).reduce((ret, v) => {
      ret[v.field] = v.values.map(value => value.name || value)
      return ret;
    }, {})
  },

  importPagination(state, paging){
    paging = paging || {}
    mutations.setPage(state, paging.current);
    mutations.setTotal(state, paging.total_results);
    mutations.setResultsPerPage(state, paging.size);
    mutations.setPageCount(state, paging.total_pages);
  },

  closeFacet(state, {facet, closed}){
    let idx = state.closedFacets.indexOf(facet.key)
    if(closed && idx < 0){
      state.closedFacets.push(facet.key)
    } else if(!closed && idx >= 0){
      state.closedFacets.splice(idx, 1)
    }
  },

  closeAllFacets(state){
    state.closedFacets = Object.keys(state.facets)
  },

  openAllFacets(state){
    state.closedFacets = []
  },

  checkFilter(state, {facet, id, checked}){
    let filter = state.filters[facet.key]
    let idx = filter? filter.indexOf(id): -1;
    if(checked && idx < 0){
      if(!filter) filter = state.filters[facet.key] = []
      filter.push(id)
    } else if(!checked && idx >= 0){
      filter.splice(idx, 1)
    }
  },

  setFilters(state, v){
    state.filters = v || {}
  },

  setFacets(state, v){
    state.facets = v || []
  },

  setDarkMode(state, v){
    state.darkMode = !!v
  },

  setViewMode(state, v){
    state.viewMode = getItemById(v, state.viewModes).id
  },

  setSearchTerm(state, v){
    state.searchTerm = v
  },

  setSortField(state, v){
    state.sortField = getItemById(v, state.sortFields).id
  },
  
  setSortDirection(state, v){
    state.sortDirection = getItemById(v, state.sortDirections).id
  },
  
  setPage(state, v){
    state.page = Math.max(1, +v || 0)
  },
  
  setResultsPerPage(state, v){
    state.resultsPerPage = Math.min(Math.max(1, +v || 20), 100)
  },
  
  setPageCount(state, v){
    state.pageCount = Math.max(1, +v || 0)
  },
  
  setTotal(state, v){
    state.total = Math.max(0, +v || 0)
  },
  
  setShowFilters(state, v){
    state.showFilters = !!v
  },
  
  setFullscreen(state, v){
    state.fullscreen = !!v
  },

  setClosedFacets(state, v){
    state.closedFacets = v
  },
  
  setCurrentItem(state, v){
    state.currentItem = v
  },

  setResults(state, v){
    state.results = v || []
  },

  setElasticService(state, v){
    state.elasticService = v
    if(v) {
      v.permanentFilters = state.permanentFilters || []
      v.setPermanentFilters()
    }
  },

}

const actions = {
  addRemoveFilter({state, getters}, {facet, filter, value}){
    return new Promise(resolve => {
      let service = state.elasticService
      let filterValue = getters.getFilterValue(facet, filter) 
      console.log("getFilterValue", {filter, filterValue})      
      if(service) {
        if(value) {
          service.addFilter(facet.key, filterValue)
        } else {
          service.removeFilter(facet.key, filterValue)
        }
        
      }
      mutations.checkFilter(state, {facet, id:filter, checked:value})
      actions.activatePermanentFilters({state, getters})
      resolve(service != null)
    })
  },

  activatePermanentFilters({state}){
    let service = state.elasticService
    if(service) {
      state.permanentFilters.forEach(f => {
        service.addFilter(f.facet, f.filter)
      })
    }
  },

  changePageSize({state}, value){
    return new Promise(resolve => {
      let service = state.elasticService
      if(service) service.setPageSize(value)
      mutations.setPageSize(state, value)
      resolve(service != null)
    })
  },

  changeSortColumn({state}, value){
    return new Promise(resolve => {
      let service = state.elasticService
      const asc = "asc" 
      if(service) service.setSort(value, asc)
      mutations.setSortField(state, value)
      mutations.setSortDirection(state, asc)
      resolve(service != null)
    })
  },

  changeSortOrder({state}, value){
    return new Promise(resolve => {
      let service = state.elasticService
      if(service) service.setSort(state.sortField, value)
      mutations.setSortDirection(state, value)
      resolve(service != null)
    })
  },

  gotoPage({state}, value){
    return new Promise(resolve => {
      let service = state.elasticService
      if(service) service.gotoPage(value)
      mutations.setPage(state, value)
      resolve(service != null)
    })
  },

  search({state}, text){
    return new Promise(resolve => {
      let service = state.elasticService
      if(service) service.search(text)
      mutations.setSearchTerm(state, text)
      resolve(service != null)
    })
  }
}

export const cmd = {
  INIT: "init",
  IMPORT_DRIVER_STATE: "importDriverState",
  IMPORT_RAW_FILTERS: "importRawFilters",
  IMPORT_PAGINATION: "importPagination",
  CLOSE_FACET: "closeFacet",
  CLOSE_ALL_FACETS: "closeAllFacets",
  OPEN_ALL_FACETS: "openAllFacets",
  CHECK_FILTER: "checkFilter",
  SET_DARK_MODE: "setDarkMode",
  SET_VIEW_MODE: "setViewMode",
  SET_SEARCH_TERM: "setSearchTerm",
  SET_SORT_FIELD: "setSortField",
  SET_SORT_DIRECTION: "setSortDirection",
  SET_PAGE: "setPage",
  SET_RESULTS_PER_PAGE: "setResultsPerPage",
  SET_PAGE_COUNT: "setPageCount",
  SET_TOTAL: "setTotal",
  SET_FILTERS: "setFilters",
  SET_FACETS: "setFacets",
  SET_SHOW_FILTERS: "setShowFilters",
  SET_FULLSCREEN: "setFullscreen",
  SET_CURRENT_ITEM: "setCurrentItem",
  SET_CLOSED_FACETS: "setClosedFacets",
  SET_RESULTS: "setResults",
  SET_ELASTIC_SERVICE: "setElasticService"
  
};

export const api = {
  ADD_REMOVE_FILTER: "addRemoveFilter",
  CHANGE_PAGE_SIZE: "changePageSize",
  CHANGE_SORT_COLUMN: "changeSortColumn",
  CHANGE_SORT_ORDER: "changeSortOrder",
  GOTO_PAGE: "gotoPage",
  SEARCH: "search"
};

export default {
  state,
  getters,
  mutations,
  actions
}
